import { endDay } from '@/apps/slideshowGame/useCalculation';

export const slide50 = {
  entry: ({ context }) => {
    endDay(context.metadata);
  },
  on: {
    CLICK_NEXT: 'slide69',
  },
  meta: {
    id: 'slide50',
    section: '65f80dc09fc1182456fc1a23',
    event: 'CLICK_NEXT',
    display: {
      backgroundColor: '',
      backgroundGradient: '',
      backgroundImage: '',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-no-repeat',
      backgroundOpacity: 1,
      backgroundVideo: '',
      transition: 'slide',
      transitionSpeed: 'default',
      backgroundTransition: 'fade',
    },
    content: [
      {
        name: 'end_day_amount',
        type: 'content',
        content: {
          src: 'https://res.cloudinary.com/dcodkxpej/image/upload/v1721806619/Decision%20making%20game/boy/bwgx7ykstsz3em5s6jzt.svg',
          prefix:
            'החיים הם כמו ארטיק - בסוף הוא נגמר ואתה נשאר עם המקל. אז שמח לבשר לכם שהקיץ הסתיים. ובזכותכם ובזכות העצות שלכם הגענו לרווח של ',
          suffix: 'שקלים',
          footerText: 'עכשיו נשארה לי התלבטות אחרונה...',
          textColor: 'text-white',
        },
      },
    ],
  },
};
export default slide50;
